import { 
    SmartToy, Image, VideoLibrary, Article, 
    BarChart, Insights, Assessment, ShowChart, 
    Groups, Share, Workspaces, 
    Speed, Security, Extension, Support
} from '@/lib/mui-optimized-imports';

export const featuresData = [
    {
        id: 'ai-content-writer',
        title: 'AI Content Writer',
        description: 'Generate engaging posts, captions, and descriptions across platforms.',
        icon: SmartToy,
        category: 'AI Content Suite',
        status: 'available',
        fullDescription: 'Leverage advanced AI to generate captivating captions, trending hashtags, stunning images, and innovative ideas, transforming your content strategy.',
        learnMoreLink: '/support/articles/ai-content-writer',
        teaserText: null
    },
    {
        id: 'ai-image-generator',
        title: 'AI Image Generator',
        description: 'Create stunning visuals with AI-powered image generation.',
        icon: Image,
        category: 'AI Content Suite',
                status: 'available',
        fullDescription: 'Seamlessly generate unique and eye-catching images using AI to complement your content and stand out on social media.',
        learnMoreLink: '/support/articles/ai-image-generator',
        teaserText: null
    },
    {
        id: 'ai-video-editor',
        title: 'AI Video Editor',
        description: 'Auto-generate video content and captions for all your social platforms.',
        icon: VideoLibrary,
        category: 'AI Content Suite',
        status: 'coming_soon',
        fullDescription: 'Our upcoming AI video editor will allow you to quickly create and edit video content, complete with auto-generated captions and effects.',
        learnMoreLink: '/support/articles/ai-video-editor',
        teaserText: 'Automate video creation and editing.'
    },
    {
        id: 'ai-blog-writer',
        title: 'AI Blog Writer',
        description: 'Generate long-form content and articles with AI assistance.',
        icon: Article,
        category: 'AI Content Suite',
        status: 'premium',
        fullDescription: 'Produce high-quality, SEO-optimized blog posts and articles in minutes, leveraging AI to research, write, and refine your content.',
        learnMoreLink: '/support/articles/ai-blog-writer',
        teaserText: null
    },
    {
        id: 'real-time-analytics',
        title: 'Real-Time Analytics',
        description: 'Monitor performance across all platforms with real-time data insights.',
        icon: BarChart,
        category: 'Analytics & Insights',
        status: 'available',
        fullDescription: 'Get immediate insights into your content performance, track engagement, reach, and audience demographics across all connected social media platforms.',
        learnMoreLink: '/support/articles/real-time-analytics',
        teaserText: null
    },
    {
        id: 'ai-insights',
        title: 'AI Insights',
        description: 'Get intelligent recommendations and predictions for optimal content strategy.',
        icon: Insights,
        category: 'Analytics & Insights',
        status: 'premium',
        fullDescription: 'Leverage AI to predict content performance, identify trending topics, and receive personalized recommendations to fine-tune your social media strategy for maximum impact.',
        learnMoreLink: '/support/articles/ai-insights',
        teaserText: 'Predictive analytics for your content.'
    },
    {
        id: 'custom-reports',
        title: 'Custom Reports',
        description: 'Create detailed, tailored reports to track what matters most to you.',
        icon: Assessment,
        category: 'Analytics & Insights',
        status: 'available',
        fullDescription: 'Generate customizable reports focusing on key metrics and campaigns, allowing you to present data clearly and make informed decisions.',
        learnMoreLink: '/support/articles/custom-reports',
        teaserText: null
    },
    {
        id: 'trend-analysis',
        title: 'Trend Analysis',
        description: 'Identify patterns and optimize your strategy with comprehensive trend analysis.',
        icon: ShowChart,
        category: 'Analytics & Insights',
        status: 'available',
        fullDescription: 'Stay ahead of the curve by identifying emerging trends, popular hashtags, and viral content patterns to ensure your strategy is always relevant and impactful.',
        learnMoreLink: '/support/articles/trend-analysis',
        teaserText: null
    },
    {
        id: 'team-collaboration',
        title: 'Team Collaboration',
        description: 'Work seamlessly with your team, assign roles, and manage content approvals.',
        icon: Groups,
        category: 'Collaboration & Management',
        status: 'available',
        fullDescription: 'Streamline your workflow with robust team management tools, allowing for easy content approval, role assignments, and shared calendars to ensure everyone is on the same page.',
        learnMoreLink: '/support/articles/team-collaboration',
        teaserText: null
    },
    {
        id: 'multi-platform-publishing',
        title: 'Multi-Platform Publishing',
        description: 'Publish and schedule content across all major social media networks.',
        icon: Share,
        category: 'Collaboration & Management',
        status: 'available',
        fullDescription: 'Reach a wider audience by effortlessly scheduling and publishing your content across multiple social media platforms from a single, intuitive dashboard.',
        learnMoreLink: '/support/articles/multi-platform-publishing',
        teaserText: null
    },
    {
        id: 'workspace-management',
        title: 'Workspace Management',
        description: 'Manage multiple brands and clients with dedicated workspaces.',
        icon: Workspaces,
        category: 'Collaboration & Management',
        status: 'premium',
        fullDescription: 'Ideal for agencies and businesses managing multiple brands, our workspace management feature provides isolated environments for each client, ensuring organized and efficient operations.',
        learnMoreLink: '/support/articles/workspace-management',
        teaserText: 'Dedicated workspaces for clients.'
    },
    {
        id: 'fast-publishing',
        title: '3x Faster Publishing',
        description: 'Publish to all platforms in seconds, significantly reducing your workflow time.',
        icon: Speed,
        category: 'Performance & Security',
        status: 'available',
        fullDescription: 'Experience unparalleled efficiency with our optimized publishing engine, allowing you to push content to all your connected platforms three times faster than traditional methods.',
        learnMoreLink: '/support/articles/fast-publishing',
        teaserText: null
    },
    {
        id: 'enterprise-security',
        title: 'Enterprise Security',
        description: 'Robust security features with SOC 2 & GDPR compliance.',
        icon: Security,
        category: 'Performance & Security',
        status: 'available',
        fullDescription: 'Rest easy knowing your data and content are protected by industry-leading security protocols, including SOC 2 and GDPR compliance, safeguarding your business from threats.',
        learnMoreLink: '/support/articles/enterprise-security',
        teaserText: null
    },
    {
        id: '16-plus-platforms',
        title: '16+ Platform Support',
        description: 'Connect and manage your presence across over 16 social media platforms.',
        icon: Extension,
        category: 'Performance & Security',
        status: 'available',
        fullDescription: 'Expand your reach and manage all your social media channels from one central hub, with comprehensive support for more than 16 major platforms and growing.',
        learnMoreLink: '/support/articles/16-plus-platforms',
        teaserText: null
    },
    {
        id: 'dedicated-support',
        title: 'Dedicated Support',
        description: 'Access to our dedicated creator success team for 24/7 assistance.',
        icon: Support,
        category: 'Support & Resources',
        status: 'available',
        fullDescription: 'Our expert creator success team is available around the clock to provide personalized support, ensuring you get the most out of FloAI Studio and resolve any issues quickly.',
        learnMoreLink: '/support',
        teaserText: null
    },
];

/** Testimonials: load from CMS/API when available. Empty until then so no seeded data. */
export const testimonialsData: Array<{ id: string; quote: string; author: string; role: string }> = [];
